import { createStyles, Typography, withStyles } from '@material-ui/core';
import React from 'react';
import { TypographyAllProps } from 'globals/types';

const FsSubtitle = withStyles(() =>
  createStyles({
    root: {},
  })
)((props: TypographyAllProps) => (
  <Typography variant="h4" component="h4" {...props} />
));

export default FsSubtitle;
